import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PendenciasService {

  readonly serviceApi = environment.apiUrl;

  constructor(private readonly http: HttpClient) { }

  gerarRelatorioPendencias(identificador: string): Observable<any> {
    return this.http.get(`${this.serviceApi}/v1/sistemas-externos/relatorio-pendencias?parametro=${identificador}`);
  }

}

